import { Monitor, Moon, Sun } from 'lucide-react';
import type { ReactElement } from 'react';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { selectTheme, type Theme, themeChanged } from '@/features/ui';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/DropdownMenu';

import { Button } from '../Button';

const THEME_LABELS: Record<Theme, string> = {
  light: 'Claro',
  dark: 'Oscuro',
  system: 'Sistema',
};

export function ThemeToggle(): ReactElement {
  const theme = useAppSelector(selectTheme);
  const dispatch = useAppDispatch();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label="Cambiar tema">
          <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => {
            dispatch(themeChanged('light'));
          }}
          className={theme === 'light' ? 'bg-muted' : ''}
        >
          <Sun className="h-4 w-4" /> {THEME_LABELS.light}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            dispatch(themeChanged('dark'));
          }}
          className={theme === 'dark' ? 'bg-muted' : ''}
        >
          <Moon className="h-4 w-4" /> {THEME_LABELS.dark}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            dispatch(themeChanged('system'));
          }}
          className={theme === 'system' ? 'bg-muted' : ''}
        >
          <Monitor className="h-4 w-4" /> {THEME_LABELS.system}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
